<div class="home-page">
  <div class="home-content">
    <div class="content-wrapper">
      <section class="dashboard-section">
        <h2 class="section-title">Your Translation Dashboard</h2>
        <div class="dashboard-cards-grid">
          <app-dashboard-card
            *ngFor="let card of dashboardCards"
            [title]="card.title"
            [description]="getCardDescription(card)"
            [buttonText]="card.buttonText"
            [icon]="card.icon"
            [showNotificationDot]="showDotForCard(card)"
            (cardClick)="navigateTo(card.route)"
          >
          </app-dashboard-card>
        </div>
      </section>
      <section class="explore-section" *ngIf="exploreCards.length > 0">
        <h2 class="section-title">Explore Others</h2>
        <p class="section-subtitle">Explore our AI-based translation services.</p>
        <div class="explore-cards-grid">
          <app-explore-card
            *ngFor="let card of exploreCards"
            [title]="card.title"
            [description]="card.description"
            [icon]="card.icon"
            [link]="card.link"
          >
          </app-explore-card>
        </div>
      </section>
    </div>
  </div>
</div>
